// Helper functions to create OpenAPI objects, and get Base URLs for Websockets.
// This module decides which URL to use for the API depending on the situation.

import * as api from "@nens/threedi/openapi-client";

const HOST = window.location.host;

// Deal with localhost:4200 for development
const parts = HOST.split(".");
let API_HOST = "hcc-api." + parts.slice(-2).join(".");

if (HOST.includes("localhost")) {
  API_HOST = HOST;
}
if (parts[0] === "test" || parts[0] === "staging") {
  API_HOST = "hcc-api." + HOST;
}

export const LIVE_SITE = HOST + "/live";

export const API_PROTOCOL = window.location.hostname === "localhost" ? "http" : "https";
const WS_PROTOCOL = window.location.hostname === "localhost" ? "ws" : "wss";

const CONFIGURATION = new api.Configuration({
  basePath: `${API_PROTOCOL}://${API_HOST}`,
  credentials: "include", // Otherwise fetch doesn't send the auth cookie
});

// Helper function to redirect the user to the right login page, and back here
// once logged in.
export const getLoginRedirectUrl = () =>
  `${API_PROTOCOL}://${API_HOST}/accounts/login/?next=/redirects/hcc-management/`;

// Helper function for when opening a Websocket, to choose between ws:// and wss://
// Note that this is only used for one of the Websockets, the others have their own
// URL decided by the backend and that works correctly already.
export const getWebsocketUrl = (apiPath: string) =>
  `${WS_PROTOCOL}://${API_HOST}${api.BASE_PATH}/${apiPath}`;

// Helper function to logout user and redirect back here
export const getLogoutUrl = () =>
  `${API_PROTOCOL}://${API_HOST}/accounts/logout/?next=/redirects/hcc-management/`;

// Remove URL parts before the path, to make development testing easier.
export const normalizeUrl = (url: string) =>
  `${API_PROTOCOL}://${API_HOST}${new URL(url).pathname}`;

// We have to define functions for each of these in order to use our configuration object

export const getAuthApi = () => new api.V3Api(CONFIGURATION);
export const getContractApi = () => new api.V3Api(CONFIGURATION);
export const getOrganisationsApi = () => new api.V3Api(CONFIGURATION);
export const getSchematisationsApi = () => new api.V3Api(CONFIGURATION);
export const getPersonalApiKeyApi = () => new api.V3BetaApi(CONFIGURATION);
export const getSimulationsApi = () => new api.V3Api(CONFIGURATION);
export const getStatusesApi = () => new api.V3Api(CONFIGURATION);
export const getThreediModelsApi = () => new api.V3Api(CONFIGURATION);
export const getUsageApi = () => new api.V3Api(CONFIGURATION);
export const getV3Api = () => new api.V3Api(CONFIGURATION);
export const getSimulationTemplatesApi = () => new api.V3Api(CONFIGURATION);
export const getStatusApi = () => new api.V3BetaApi(CONFIGURATION);
